import { KText } from '@/ui-library/components/text';
import { Avatar, Flex, Icon } from '@chakra-ui/react';
import { DuelToneUser } from '@/assets/icons/form/DuelToneUser';

export const SelectOptionWithAvatar = (
  option = {},
  labelKey = 'label',
  item
) => {
  const {
    avatar,
    emailKey = 'email',
    role_name = '',
    withRole = false,
    hideAvatar = false,
    isPool = false,
    customText = '',
  } = option;

  const { withEmail = false } = item || {};

  const userRole = role_name
    ?.replace(/_/g, ' ')
    ?.replace(/\b\w/g, (c) => c.toUpperCase());

  const name = `${option?.[labelKey] || ''} ${
    withEmail && option?.[emailKey] ? `(${option?.[emailKey]})` : ''
  } ${withRole ? `(${userRole})` : ''}`;

  if (hideAvatar) {
    return <KText id={`react-select`}>{name}</KText>;
  }

  return (
    <Flex gap="6px" alignItems="center" id={`react-select`}>
      {isPool ? (
        <Icon as={DuelToneUser} width="18px" height="18px" />
      ) : (
        <Avatar
          src={avatar}
          name={name}
          width="16px"
          height="16px"
          borderRadius="3px"
          className="avatar-xs"
        />
      )}
      <KText>{name}</KText>
      {customText && (
        <KText display="inline" color="secondary-500">
          ({customText})
        </KText>
      )}
    </Flex>
  );
};
